'use strict';

angular.module('app')
  .directive('paymentMethodsList', function (paymentService) {
    var controller = function ($scope) {
      var vm = this;
      vm.cardFormVisible = false;
      vm.initPaymentMethod = initPaymentMethod;
      vm.submitSEPA = submitSEPA;
      vm.submitCard = submitCard;
      vm.setCreditCardForm = setCreditCardForm;
      vm.success = $scope.success;

      function initPaymentMethod() {
        if (vm.paymentType === 10 || vm.paymentType === 20 || vm.paymentType === 30) {
          // credit cards;
          var contId = '#paymentMethodContainer' + vm.paymentType;
          $('#cardForm').appendTo(contId);
          vm.cardFormVisible = true;

          if (vm.paymentProcessor === 10) {
            paymentService.createPaymentForm();
          } else if (vm.paymentProcessor === 70) {
            paymentService.createAdyenCardForm();
          }
        } else if (vm.paymentType === 40) {
          // sepa
          paymentService.createIbanForm();
        }
      }

      function submitSEPA(form) {
        form.$submitted = true;

        if (form.$valid && !vm.loader) {
          vm.loader = true;
          var ibanData = {name: vm.ibanName, email: vm.ibanEmail};

          paymentService.createSourceFromIban(ibanData, function (response) {
            $scope.$apply(function () {
              vm.loader = false;
            });
            if (!response.error) {
              $scope.$apply(function () {
                vm.success = true;
              });
            }
            if (typeof vm.callbackFn === 'function') vm.callbackFn(response, vm.paymentType);
          }).catch(function () {
            vm.loader = false;
          });
        }
      }

      function submitCard(form) {
        form.$submitted = true;
        var paymentData = {};

        if (form.$valid && !vm.loader) {
          // STRIPE
          vm.loader = true;
          if (vm.paymentProcessor === 10) {
            paymentService.createSource(function (response) {
              $scope.$apply(function () {
                vm.loader = false;
              });
              if (!response.error) {
                $scope.$apply(function () {
                  vm.success = true;
                });
              }
              if (typeof vm.callbackFn === 'function') vm.callbackFn(response, vm.paymentType);
            }).catch(function () {
              vm.loader = false;
            });
            // ADYEN
          } else if (vm.paymentProcessor === 70) {
            paymentData = paymentService.getAdyenPaymentData();
            if (paymentData) {
              if (typeof vm.callbackFn === 'function') vm.callbackFn(paymentData, vm.paymentType);
              vm.success = true;
            }
            vm.loader = false;
            returnError('Card information is not complete');
          }
        } else {
          returnError('Invalid payment form');
        }
      }

      function returnError(text) {
        var response = {};
        if (typeof vm.callbackFn === 'function') {
          response.error = {};
          response.error.message = text;
          vm.callbackFn(response);
        }
        return false;
      }

      function setCreditCardForm(form) {
        vm.cardForm = form;
      }

      $scope.$on('createSource', function (event) {
        if (vm.paymentType === 10 || vm.paymentType === 20 || vm.paymentType === 30) {
          submitCard(vm.cardForm);
        } else if (vm.paymentType === 40) {
          submitSEPA($scope.ibanForm);
        } else {
          return false;
        }
      });
    };

    return {
      restrict: 'A',
      templateUrl: window.templatePath ? window.templatePath + 'templates/_payment-methods-list.html' : '../templates/_payment-methods-list.html',
      controller: controller,
      controllerAs: 'ctrl',
      bindToController: true,
      scope: {
        paymentMethods: '=',
        callbackFn: '=',
        success: '=',
        successMessage: '@',
        buttonText: '@',
        hideSubmit: '=',
        paymentType: '=',
        paymentProcessor: '=',
        hideSepa: '=',
      },
    };
  });
